import React from "react";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const resolvePhoto = (photo) =>
  photo && photo.startsWith("/") ? `${process.env.REACT_APP_BACKEND_URL}${photo}` : photo;

export const formatDate = (d) =>
  new Date(d + "T00:00:00").toLocaleDateString("en-US", { month: "long", day: "numeric", year: "numeric" });

export const formatStamp = (u) => {
  if (u.timestamp) {
    const dt = new Date(u.timestamp);
    const date = dt.toLocaleDateString("en-US", { month: "short", day: "numeric" }).toUpperCase();
    const time = dt.toLocaleTimeString("en-US", { hour: "numeric", minute: "2-digit" });
    return `${date} AT ${time}`;
  }
  return new Date(u.date + "T00:00:00")
    .toLocaleDateString("en-US", { month: "short", day: "numeric" })
    .toUpperCase();
};

export const SectionHead = ({ label, title, subtitle }) => (
  <div className="mb-6">
    <div className="text-xs uppercase tracking-[0.25em] text-primary">{label}</div>
    <h2 className="mt-2 font-serif text-2xl sm:text-3xl text-foreground">{title}</h2>
    {subtitle && <p className="mt-2 text-sm text-muted-foreground">{subtitle}</p>}
  </div>
);

export const inputCls =
  "w-full h-11 rounded-2xl bg-secondary/60 border-0 px-4 text-sm placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary/40";

export const textareaCls =
  "w-full rounded-2xl bg-secondary/60 border-0 px-4 py-3 text-sm placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary/40 min-h-[90px] resize-none";
